import Vue from 'vue'
import VueRouter from 'vue-router'
// import Welcome from './components/welcome/welcome.vue'
import Dashboard from './components/dashboard/dashboard.vue'
import Profile from './elements/profile/profile.vue'
import Pwdchange from './elements/profile/pwdchange'
import Leaderboard from './elements/leaderboard/leaderboard.vue'
import Register from './components/auth/register.vue'
import Login from './components/auth/login.vue'
import Confirm from './components/auth/confirm.vue'
import Categories from './elements/list_categories/categories.vue'
import Areas from './elements/list_areas/areas.vue'
import Courses from './elements/list_courses/courses.vue'
import CoursePreview from './elements/course/course_preview.vue'
import CourseContent from './elements/course/course_content.vue'
import CourseAdminContent from './elements/course/course_admin_content.vue'
import BookGenerator from './elements/course/book_generator.vue'
import ChapterContent from './elements/course/chapter_content.vue'

import CompetitionContent from './elements/competitions/competition_content.vue'
import CompetitionResult from './elements/competitions/competition_result.vue'


import ShowSolutions from './elements/competitions/ShowSolutions.vue'
import ShowCompetition from '../src/elements/competitions/show_competition.vue'

import TeacherDashboard from './elements/teacher/teacher_dashboard.vue'
import TeacherStudents from './elements/teacher/teacher_students.vue'
import TeacherChapters from './pages/teacher_chapters.vue'
import TeacherLessons from './pages/teacher_lessons.vue'
import TeacherTasks from './pages/teacher_tasks.vue'
import TeacherTaskDetail from './pages/teacher_task_detail.vue'


import Test from './elements/course/test.vue'

import AdminContent from './elements/admin/tasks_old/admin_content.vue'
import AdminType24 from './elements/admin/tasks_old/admin_type24.vue'
import AdminType56 from './elements/admin/tasks_old/admin_type56.vue'
import AdminType7 from './elements/admin/tasks_old/admin_type7.vue'
import AdminType8 from './elements/admin/tasks_old/admin_type8.vue'
import AdminType_11 from './elements/admin/tasks_old/admin_type_11.vue'
import ShowContent from './elements/admin/tasks_old/show_content.vue'

import LessonAdminContent from './elements/admin/lesson/lesson_admin_content.vue'
 
import AdminCategory from './elements/admin/lists_old/admin_category.vue'
import AdminArea from './elements/admin/lists_old/admin_area.vue'
import AdminCourse from './elements/admin/lists_old/admin_course.vue'
import AdminChapter from './elements/admin/lists_old/admin_chapter.vue'
import AdminLesson from './elements/admin/lists_old/admin_lesson.vue'
import EditChapters from './elements/admin/course_content/echapters.vue'
import EditLessons from './elements/admin/course_content/elessons.vue'
import EditTasksList from './elements/admin/course_content/etask_list.vue'
import EditTask from './elements/admin/course_content/etask.vue'



import Groups from '../src/elements/groups/groups.vue'
import UsersActivity from '../src/elements/dataprocessing/UsersActivity.vue'

import QueList from '../src/elements/questionaires/que_list.vue'
import Questionnaire from '../src/elements/questionaires/questionnaire.vue'
import MyQuestionnaire from '../src/elements/questionaires/my_questionnaire.vue'
import MyQuestionnaires from '../src/elements/questionaires/my_questionnaires'
import MessageAdminList from '../src/elements/messages/message_admin_list.vue'

import MessageAdminDetail from '../src/elements/messages/message_admin_detail.vue'
import MessageList from '../src/elements/messages/message_user_list.vue'

import ShowKernels from '../src/components/jprcomponents/show_kernels.vue'

import TeacherQuizzes from './pages/teacher_quizzes.vue'
import TeacherGroups from './pages/teacher_groups.vue'
import StudentSettings from './pages/student_settings.vue'
import StudentQuizzes from './pages/student_quizzes.vue'
import StudentDuels from './pages/student_duels.vue'

import RevisionsStudent from './pages/revisions_student.vue'
import RevisionStudent from './pages/revision_student.vue'
import RevisionsTeacher from './pages/revisions_teacher.vue'
import TeacherCompetitions from './pages/teacher_competitions.vue'
import RevisionsTeacherRevisions from './pages/revisions_teacher_revisions.vue'

import CourseTeachers from './pages/course_teachers.vue'

import CognitiveTests from './pages/cogtests/test_list.vue'
import CognitiveTest from './pages/cogtests/cog_test.vue'

import PersonalisationTests from './pages/person_tests/pers_test_list.vue'
import PersonalisationTest from './pages/person_tests/pers_test.vue'

// import store from './store'

Vue.use(VueRouter)

let router = new VueRouter({
  mode: 'history', 
  routes : [
    { path: '/404', 
      component: Login, 
      meta: {
        title : 'Login'
      }
    },
    { 
      path: '/login', 
      name: 'login',
      component: Login,
      meta: {
        title : 'Login',
        requiresAuth : false,
        forUser : false,
        forAdmin: false
      }
    },  
/*    { path: '/', 
      name: 'welcome',
      component: Welcome,
      meta: {
        title : 'Welcome',
        requiresAuth : false,
        forUser : false,
        forAdmin: false
      }
    },*/ { 
      path: '/register', 
      name: 'register',
      component: Register,
      meta: {
        title : 'Register',
        requiresAuth : false,
        forUser : false,
        forAdmin: false
      },
    }, { 
      path: '/confirm/:mail/:token', 
      name: 'confirm',
      component: Confirm,
      meta: {
        title : 'Confirm',
        requiresAuth : false,
        forUser : false,
        forAdmin: false
      },
    }, { 
      path: '/dashboard', 
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title : 'Dashboard',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/profile', 
      name: 'profile',
      component: Profile,
      meta: {
        title : 'Profile',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/pwdchange', 
      name: 'pwdchange',
      component: Pwdchange,
      meta: {
        title : 'Password change',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/leaderboard', 
      name: 'leaderboard',
      component: Leaderboard,
      meta: {
        title : 'Leaderboard',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/show_competition/:id', 
      name: 'show_competition',
      component: ShowCompetition,
      meta: {
        title : 'Show competition',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    },{ 
      path: '/message_list/:id?', 
      name: 'message_list',
      component: MessageList,
      meta: {
        title : 'Message list',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    },{ 
      path: '/que_list', 
      name: 'que_list',
      component: QueList,
      meta: {
        title : 'Questionnaires',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/message_admin_list', 
      name: 'message_admin_list',
      component: MessageAdminList,
      meta: {
        title : 'Messages list',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    },{ 
      path: '/edit_message/:id', 
      name: 'edit_message',
      component: MessageAdminDetail,
      meta: {
        title : 'Message',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/questionnaire/:id', 
      name: 'questionnaire',
      component: Questionnaire,
      meta: {
        title : 'Questionnaire',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    },{ 
      path: '/myquestionnaire/:id', 
      name: 'myquestionnaire',
      component: MyQuestionnaire,
      meta: {
        title : 'My questionnaire',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    },{ 
      path: '/myquestionnaires', 
      name: 'myquestionnaires',
      component: MyQuestionnaires,
      meta: {
        title : 'My questionnaires',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/users_activity', 
      name: 'users_activity',
      component: UsersActivity,
      meta: {
        title : 'Show activity',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/categories', 
      name: 'categories',
      component: Categories,
      meta: {
        title : 'Categories',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/areas/:id', 
      name: 'areas',
      component: Areas,
      meta: {
        title : 'Areas',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/courses/:id', 
      name: 'courses',
      component: Courses,
      meta: {
        title : 'Courses',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/course_admin_content/:id', 
      name: 'course_admin_content',
      component: CourseAdminContent,
      meta: {
        title : 'Course admin content',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/course_preview/:id', 
      name: 'course_preview',
      component: CoursePreview,
      meta: {
        title : 'Course preview',
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    },{ 
      path: '/course_content/:id', 
      name: 'course_content',
      component: CourseContent,
      meta: {
        title : 'Course content',
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    },{ 
      path: '/chapter_content/:id', 
      name: 'chapter_content',
      component: ChapterContent,
      meta: {
        title : 'Chapter content',
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    },{ 
      path: '/show_solutions/:id', 
      name: 'show_solutions',
      component: ShowSolutions,
      meta: {
        title : 'Show solutions',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    },{ 
      path: '/competition_content/:id', 
      name: 'competition_content',
      component: CompetitionContent,
      meta: {
        title : 'Competition',
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    }, { 
      path: '/competition_result/:id', 
      name: 'competition_result',
      component: CompetitionResult,
      meta: {
        title : 'Competition result',
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    }, { 
      path: '/lesson_admin_content/:id', 
      name: 'lesson_admin_content',
      component: LessonAdminContent,
      meta: {
        title : 'Lesson admin content',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_content/:lesson_id/:id', 
      name: 'admin_content',
      component: AdminContent,
      meta: {
        title : 'Admin content',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    },{ 
      path: '/show_content/:id', 
      name: 'show_content',
      component: ShowContent,
      meta: {
        title : 'Show content',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type24/:lesson_id/:id', 
      name: 'admin_type24',
      component: AdminType24,
      meta: {
        title : 'Edit question 2, 3, 4',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type56/:lesson_id/:id', 
      name: 'admin_type56',
      component: AdminType56,
      meta: {
        title : 'Edit question 5 or 6',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type7/:lesson_id/:id', 
      name: 'admin_type7',
      component: AdminType7,
      meta: {
        title : 'Edit question 7',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type8/:course_id/:lesson_id/:id', 
      name: 'admin_type8',
      component: AdminType8,
      meta: {
        title : 'Edit program 8, 9, 10',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    },{ 
      path: '/admin_type_11/:lesson_id/:id', 
      name: 'admin_type_11',
      component: AdminType_11,
      meta: {
        title : 'Edit program 11',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_category/:id', 
      name: 'admin_category',
      component: AdminCategory,
      meta: {
        title : 'Edit category',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_area/:category_id/:id', 
      name: 'admin_area',
      component: AdminArea,
      meta: {
        title : 'Edit area',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_chapter/:area_id/:course_id/:id/:ch_type', 
      name: 'admin_chapter',
      component: AdminChapter,
      meta: { 
        title : 'Edit chapter',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_course/:category_id/:area_id/:id', 
      name: 'admin_course',
      component: AdminCourse,
      meta: {
        title : 'Edit course',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/book_generator/:id', 
      name: 'book_generator',
      component: BookGenerator,
      meta: {
        title : 'Book generator',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_lesson/:course_id/:chapter_id/:id', 
      name: 'admin_lesson',
      component: AdminLesson,
      meta: {
        title : 'Edit lesson',
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/test/', 
      name: 'Test',
      component: Test,
      meta: {
        title : 'Test',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }, 
    }, { 
      path: '/teacher_dashboard/', 
      name: 'teacher_dashboard',
      component: TeacherDashboard,
      meta: {
        title : 'Teacher dashboard',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
  },{ 
    path: '/groups/', 
    name: 'groups',
    component: Groups,
    meta: {
      title : 'Groups',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/teacher_chapters/:course_id', 
    name: 'teacher_chapters',
    component: TeacherChapters,
    meta: {
      title : 'Chapters of course',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/teacher_lessons/:course_id/:chapter_id', 
    name: 'teacher_lessons',
    component: TeacherLessons,
    meta: {
      title : 'Lessons in course chapter',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },  { 
    path: '/teacher_tasks/:course_id/:chapter_id/:lesson_id', 
    name: 'teacher_tasks',
    component: TeacherTasks,
    meta: {
      title : 'Tasks in course lesson',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },  { 
    path: '/teacher_task_detail/:course_id/:chapter_id/:lesson_id/:task_id', 
    name: 'teacher_task_detail',
    component: TeacherTaskDetail,
    meta: {
      title : 'Task details',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/edit_chapters/:id', 
    name: 'edit_chapters',
    component: EditChapters,
    meta: {
      title : 'Edit course',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },
  { 
    path: '/edit_lessons/:id', 
    name: 'edit_lessons',
    component: EditLessons,
    meta: {
      title : 'Edit chapter',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },
  { 
    path: '/task_list/:id', 
    name: 'task_list',
    component: EditTasksList,
    meta: {
      title : 'Lessons tasks',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },  { 
    path: '/show_kernels/', 
    name: 'show_kernels',
    component: ShowKernels,
    meta: {
      title : 'Show kernels',
      requiresAuth : true,
      forUser : false,
      forAdmin: true
    }
  },  { 
    path: '/task_edit/:course_id/:lesson_id/:id_type/:show_lang/:edit_lang/:id', 
    name: 'task_edit',
    component: EditTask,
    meta: {
      title : 'Edit task',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },  { 
    path: '/teacher_quizzes/:id', 
    name: 'teacher_quizzes',
    component: TeacherQuizzes,
    meta: {
      title : 'Teacher Quizzes',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/teacher_groups/:id', 
    name: 'teacher_groups',
    component: TeacherGroups,
    meta: {
      title : 'Teacher Groups',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/student_settings/:id', 
    name: 'student_settings',
    component: StudentSettings,
    meta: {
      title : 'My student settings',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/student_quizzes/:id', 
    name: 'student_quizzes',
    component: StudentQuizzes,
    meta: {
      title : 'My Quizzes',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/student_duels/:id', 
    name: 'student_duels',
    component: StudentDuels,
    meta: {
      title : 'My Duels',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/course_teachers/:id', 
    name: 'course_teachers',
    component: CourseTeachers,
    meta: {
      title : 'Course teachers',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },{ 
    path: '/revisions_student/:course_id', 
    name: 'revisions_student',
    component: RevisionsStudent,
    meta: {
      title : 'Revisions student',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },{ 
    path: '/revision_student/:course_id/:rev_id', 
    name: 'revision_student',
    component: RevisionStudent,
    meta: {
      title : 'Revision student',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },{ 
    path: '/revisions_teacher/:id', 
    name: 'revisions_teacher',
    component: RevisionsTeacher,
    meta: {
      title : 'Revisions teacher',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },{ 
    path: '/revisions_teacher_revisions/:course_id', 
    name: 'revisions_teacher_revisions',
    component: RevisionsTeacherRevisions,
    meta: {
      title : 'Revisions teacher_revisions',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  },{ 
    path: '/teacher_competitions/:course_id', 
    name: 'teacher_competitions',
    component: TeacherCompetitions,
    meta: {
      title : 'Revisions teacher_revisions',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
  }, { 
    path: '/teacher_students/:course_id/:group_id', 
    name: 'teacher_students',
    component: TeacherStudents,
    meta: {
      title : 'Students of teacher',
      requiresAuth : true,
      forUser : true,
      forAdmin: true
    }
    }, { 
      path: '/cognitive_tests', 
      name: 'cognitive_tests',
      component: CognitiveTests,
      meta: {
        title : 'Cognitive tests',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    },  { 
      path: '/cognitive_test/:id', 
      name: 'cognitive_test',
      component: CognitiveTest,
      meta: {
        title : 'Cognitive test',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/personalisation_tests', 
      name: 'personalisation_tests',
      component: PersonalisationTests,
      meta: {
        title : 'Personalisation tests',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    },  { 
      path: '/personalisation_test/:id', 
      name: 'personalisation_test',
      component: PersonalisationTest,
      meta: {
        title : 'Personalisation test',
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    },
  ]
})

/*
router.afterEach((to, from) => {
  if (from.name == 'task_edit') {
    localStorage.setItem('mydata','ideeeeeeeeeeeeeeeem')
    return
 }
})
*/

router.beforeEach((to, from, next) => {

  if (from.name == to.name) {
    /* eslint-disable no-console 
    console.log(from.name)
    console.log(next.name)
    return*/
  }

  const requiresAuth = to.matched.some(record  => record.meta.requiresAuth)
  const forAdmin = to.matched.some(record  => record.meta.forAdmin)
  const forUser = to.matched.some(record  => record.meta.forUser)
  var isLogged = false
  var isAdmin = false
  if (localStorage != null) {
      isLogged = localStorage.getItem('token') != null  
      isAdmin = localStorage.getItem('role_id') == 2
  }

   if (to.name == 'confirm') {
     localStorage.setItem('confirm','1')
     next()
     return
   }

     // last change for login edit 2025-06-16
  if (requiresAuth && !isLogged) {
    localStorage.setItem('redirect',to.fullPath)
    next({ name: 'login' })
    return
  }
  // last change for login edit 2025-06-16 - end

  if(!requiresAuth) { 
    if (!isLogged) {
      next()
      return
    } else {
      next( { name: 'dashboard'} )
      return  
    }
  }

  if (isAdmin && forAdmin) {
    next()
    return
  }

  if (isAdmin && !forAdmin) {
    next( { name: 'dashboard'} )
    return
  }

  // is user
  if (!forUser) {
    next( { name: 'dashboard'} )
    return
  }
  
  next()
 
})


export default router
